<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <stock-logs :isActive="activeLogs" @close="activeLogs = !activeLogs"/>
    <set-stock-limits :isActive="activeLimits" @close="activeLimits = !activeLimits"/>
    <vs-popup class="holamundo" title="Hammadde Sil" :active.sync="deletePopupActive" v-esc="escapeDelete">
      <div class="w-full" @keyup.enter="deleteData(deletedId)">
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Hammaddeyi Silmek İstediğinize Eminmisiniz ? </p>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç
          </vs-button>
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
                     @click="deleteData(deletedId)">
            Sil
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>

    <!-- Barcode Update Dialog -->
    <vs-popup class="holamundo" title="Barkod Güncelle" :active.sync="barcodePopupActive" v-esc="escapeBarcode">
      <div class="w-full" @keyup.enter="updateBarcode">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="12" class="mb-3">
            <vs-input
              v-model="selectedStock.barcode"
              class="w-full"
              label="Barkod"
              placeholder="Barkod giriniz"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="primary" @click="barcodePopupActive = false">Vazgeç</vs-button>
          <vs-button type="gradient" color="success" @click="updateBarcode">Güncelle</vs-button>
        </vs-row>
      </div>
    </vs-popup>

    <vs-table id="stockDataList" ref="table" :data="stocks" :max-items="itemsPerPage" v-model="selected">

      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                         :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                         @saveOptions="saveOptions" @close="isFilterActive = false;"/>
          <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
            <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button @click="isFilterActive = !isFilterActive;"
                               class="panel-action text-warning xlarge-button panel-action-box-shadow"
                               color="transparent"
                               icon-pack="pickicon" icon="icon-pick-filter">
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Stok Hareketleri" position="top">
                    <vs-button @click="activeLogs = !activeLogs"
                               class="panel-action text-dark xlarge-button panel-action-box-shadow" color="transparent"
                               icon-pack="pickicon" icon="icon-checklist"/>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                               color="transparent" icon-pack="feather" icon="icon-download"/>
                  </vx-tooltip>
                  <vs-col v-if="$isCenterBranch" vs-type="flex" class="w-auto">
                    <vx-tooltip text="Stok Limitleri Belirle" position="top">
                      <vs-button @click="activeLimits = !activeLimits"
                                 class="panel-action text-dark xlarge-button panel-action-box-shadow"
                                 color="transparent"
                                 icon-pack="feather" icon="icon-bar-chart"/>
                    </vx-tooltip>
                  </vs-col>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
                <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                           class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather"
                           icon="icon-slash" radius
                           color="transparent"/>
                <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                  <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                           v-show="chip.value != '' " closable>
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + ' :' }}
                        </span>
                      </vs-col>
                      <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                        <span class="weight-600 italic text-xsmaller text-primary">
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end">
              <vs-dropdown vs-trigger-click class="bg-white cursor-pointer panel-action-box-shadow">
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small">
                  <span class="mr-2 page-size-dropdown-span">{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0 ? (currentPage + 1) * itemsPerPage : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">

        <vs-th class="w-1/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.StockCode') ? sortingHeadIcon : null" color="primary"
                     type="flat" @click="setSortingOptions('rawMaterial.StockCode')">Kod
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.RawMaterialCategory.Name') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('rawMaterial.RawMaterialCategory.Name')">Kategori
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.Name') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('rawMaterial.Name')">İsim
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'buyPrice') ? sortingHeadIcon : null" color="primary" type="flat"
                     @click="setSortingOptions('buyPrice')">Maaliyet
          </vs-button>
        </vs-th>
        <vs-th v-if="isQuantityPermission || $isCenterBranch() || $isRegionalCenterBranch()" class="w-1/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'buyPrice') ? sortingHeadIcon : null" color="primary" type="flat"
                     @click="setSortingOptions('buyPrice')">Toplam Maaliyet
          </vs-button>
        </vs-th>
        <vs-th v-if="isQuantityPermission || $isCenterBranch() || $isRegionalCenterBranch()" class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'totalQuantity') ? sortingHeadIcon : null" color="primary"
                     type="flat"
                     @click="setSortingOptions('totalQuantity')">Miktar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button class="p-1 weight-600" icon-pack="feather"
                     :icon="(tableOptions.sortBy == 'rawMaterial.Supplier.Name') ? sortingHeadIcon : null"
                     color="primary"
                     type="flat" @click="setSortingOptions('rawMaterial.Supplier.Name')">Tedarikçi
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12" v-if="$isCenterBranch() || $isAdmin()">
          <vs-button class="p-1 weight-600" color="primary" disabled="true" type="flat">İşlem</vs-button>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="w-1/12">
            <p class="text-center">{{ tr.rawMaterial.stockCode }}</p>
          </vs-td>
          <vs-td class="w-3/12">
            <p class="text-center">{{ tr.rawMaterial.rawMaterialCategoryName }}</p>
          </vs-td>
          <vs-td class="w-3/12">
            <p class="text-center">{{ tr.rawMaterial.name }}</p>
          </vs-td>

          <vs-td class="w-2/12">
            <p class="text-center m-auto" style="width:fit-content;">
              <vs-chip color="primary">
                {{ $toCurrency(tr.rawMaterial.buyPrice) }}
              </vs-chip>
              <vs-chip color="transparent text-dark">%{{ tr.rawMaterial.kdv }}</vs-chip>
            </p>
          </vs-td>
          <vs-td v-if="isQuantityPermission || $isCenterBranch() || $isRegionalCenterBranch()" class="w-1/12">
            <p class="text-center m-auto" style="width:fit-content;">
              <vs-chip color="primary">
                {{ $toCurrency(tr.totalPrice) }}
              </vs-chip>
            </p>
          </vs-td>
          <vs-td v-if="isQuantityPermission || $isCenterBranch() || $isRegionalCenterBranch()" class="w-2/12">
            <p class="text-center">{{ tr.totalQuantity }} {{ tr.rawMaterial.unit.name }} </p>
          </vs-td>

          <vs-td class="w-2/12">
            <p class="text-center">{{ tr.rawMaterial.supplier ? tr.rawMaterial.supplier.name : null }}</p>
          </vs-td>

          <vs-td class="w-1/12" v-if="$isCenterBranch() || $isAdmin()">
            <feather-icon v-if="$isCenterBranch()" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                          @click.stop="deletedId = tr.id;deletePopupActive = true;"/>
            <feather-icon v-if="$isAdmin()" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                          @click.stop="editStock(tr.id)"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default :setCurrentPage="tableOptions.pageIndex" :totalLenght="calculatePageLength"
                        @currentPage="getCurrentPage"></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import moduleStock from "@/store/stock/moduleStock.js";
import StockLogs from "./StockLogs.vue";
import SetStockLimits from "./SetStockLimits";
import {isGranted} from "@/utils/auth";
import {
  deleteStock,
  getExcel,
  updateStockBarcode
} from "@/api/Stock";
/* eslint-disable */
export default {
  components: {
    PaginationDefault,
    StockLogs,
    GlobalFilter,
    SetStockLimits
  },
  data() {
    return {
      activeLimits: false,
      deletePopupActive: false,
      deletedId: null,
      selected: "",

      // New properties for barcode update
      barcodePopupActive: false,
      selectedStock: {
        id: null,
        barcode: ''
      },

      activeLogs: false,
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      tableOptions: {},
      isFilterActive: false,
      filterOptions: ["branch", "stockCode", "stock", "cost", "quantity", "supplier"],
      filterOptionNames: ["Şube", "Stok Kodu", "Stok", "Maaliyet", "Miktar", "Tedarikçi"],
      filterChips: []
    };
  },
  computed: {
    stocks() {
      return this.$store.state.stock.stocks;
    },
    totalDataRow() {
      return this.$store.state.stock.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return (mod > 0) ? ((this.totalDataRow - mod) / this.itemsPerPage) + 1 : this.totalDataRow / this.itemsPerPage;
    },
    isQuantityPermission(){
      return isGranted("stock_quantity_read")
    }
  },
  methods: {
    editStock(id) {
      const stock = this.stocks.find(s => s.id === id);
      if (stock) {
        this.selectedStock.id = id;
        this.selectedStock.barcode = stock.barcode || '';
        this.barcodePopupActive = true;
      }
    },

    updateBarcode() {
      if (!this.selectedStock.id) return;

      updateStockBarcode(this.selectedStock.id, this.selectedStock.barcode)
        .then(res => {
          if (res && res.status === 200) {
            // Update the stock in the list
            const stockIndex = this.stocks.findIndex(s => s.id === this.selectedStock.id);
            if (stockIndex >= 0) {
              this.stocks[stockIndex].barcode = this.selectedStock.barcode;
            }

            this.barcodePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Barkod başarıyla güncellendi!"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Barkod güncelleme işlemi başarısız!"
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Barkod güncelleme işlemi başarısız: " + error.response.data.Errors[0].Message
          });
        });
    },

    escapeBarcode() {
      if (this.barcodePopupActive) {
        this.barcodePopupActive = false;
        this.selectedStock = { id: null, barcode: '' };
      }
    },

    getExcel() {
      getExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Stok Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
              .name +
            " " + now.getFullYear() + '.xlsx');

          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "RawMaterial.RawMaterialCategory.Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$currentUser.branch,
        stockCode: null,
        stock: null,
        cost: {
          min: null,
          max: null
        },
        quantity: {
          min: null,
          max: null
        },
        supplier: null
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escapeDelete() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    deleteData(id) {
      deleteStock(id).then(res => {
        if (res && res.status == 200) {
          this.$store.dispatch("stock/removeStock", id).then((data) => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Stok Başarıyla Silindi"
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !"
          });
        }
      });
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? this.selected = "" : null;
    },
    getStockList: function () {
      this.$store.dispatch("stock/fetchDataListItemsStock", this.tableOptions).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error
        });
      });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    }
  },
  created: function () {
    if (!moduleStock.isRegistered) {
      this.$store.registerModule("stock", moduleStock);
      moduleStock.isRegistered = true;
    }
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.getStockList();
      }
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    }
  }
};

</script>

<style>
  #stockDataList .con-tablex {
    max-height: calc(100vh - 215px);
    overflow-y: auto;
  }
  </style>
